var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NavViewGrid,{scopedSlots:_vm._u([{key:"nav-menu",fn:function(){return [_c(_setup.MainNavMenu)]},proxy:true},{key:"mobile-nav-menu",fn:function(){return [_c(_setup.MainNavMenu)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }